export const PLAYER_BUTTON_SIZES = {
  SIZE_10: '--player-button-size-10',
  SIZE_20: '--player-button-size-20',
} as const
export type PLAYER_BUTTON_SIZES =
  (typeof PLAYER_BUTTON_SIZES)[keyof typeof PLAYER_BUTTON_SIZES]
